import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'star-check',
  size: 24,
  node: [
    [
      'path',
      {
        d: 'm19.06 12.501 2.78-2.707a.53.53 0 0 0-.294-.905l-5.166-.755a2.1 2.1 0 0 1-1.595-1.16l-2.31-4.68a.53.53 0 0 0-.95.001L9.216 6.974a2.1 2.1 0 0 1-1.597 1.16l-5.165.755a.53.53 0 0 0-.294.906l3.736 3.637a2.1 2.1 0 0 1 .611 1.879l-.88 5.139a.53.53 0 0 0 .769.56l4.617-2.428.027-.014',
        key: '14g7km',
      },
    ],
    ['path', { d: 'm15 18 2 2 4-4', key: '1szwhi' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name StarCheck
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTkuMDYgMTIuNTAxIDIuNzgtMi43MDdhLjUzLjUzIDAgMCAwLS4yOTQtLjkwNWwtNS4xNjYtLjc1NWEyLjEgMi4xIDAgMCAxLTEuNTk1LTEuMTZsLTIuMzEtNC42OGEuNTMuNTMgMCAwIDAtLjk1LjAwMUw5LjIxNiA2Ljk3NGEyLjEgMi4xIDAgMCAxLTEuNTk3IDEuMTZsLTUuMTY1Ljc1NWEuNTMuNTMgMCAwIDAtLjI5NC45MDZsMy43MzYgMy42MzdhMi4xIDIuMSAwIDAgMSAuNjExIDEuODc5bC0uODggNS4xMzlhLjUzLjUzIDAgMCAwIC43NjkuNTZsNC42MTctMi40MjguMDI3LS4wMTQiIC8+CiAgPHBhdGggZD0ibTE1IDE4IDIgMiA0LTQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/star-check
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const StarCheck = createLucideIcon(__iconData);

export default StarCheck;
